// 仅保留本页实测的时间与消息标识；不保存正文，不把历史落库时间冒充客户端发送时间。
const requests = new Map();
const answers = new Map();
const limit = 256;

/** 租户、查看者和会话共同隔离计时，三个Agent及多个窗口不会借用彼此的开始时间。 */
export function responseTimingScope(viewerId, conversation) {
  return viewerId && conversation?.conversationId
    ? JSON.stringify([conversation.tenantId || "", String(viewerId), conversation.conversationId])
    : "";
}

/** 两组映射分别有界，避免常驻聊天页无限保留旧请求。 */
function remember(map, key, value) {
  map.delete(key);
  map.set(key, value);
  if (map.size > limit) map.delete(map.keys().next().value);
}

/** 只接受本窗口亲自观察到的客户发送中消息；重试以新一次发送时间为准。 */
export function rememberResponseStart(scope, message) {
  const startedAt = Date.parse(message?.createdAt);
  if (!scope || message?.actorType !== "CUSTOMER" || message.localStatus !== "SENDING"
    || !message.clientMessageId || !Number.isFinite(startedAt)) return;
  const key = JSON.stringify([scope, message.clientMessageId]);
  const previous = requests.get(key);
  if (!previous?.answerId) remember(requests, key, { startedAt });
}

/** 已完成回答在本页重新打开时沿用实测值，不能因重新播放或历史加载继续累加。 */
export function responseDuration(scope, answerId) {
  return answers.get(JSON.stringify([scope, answerId])) ?? null;
}

/** 在回答最后一次Vue布局提交后结束；没有本地起点或同一问题已关联其他回答时不猜测。 */
export function completeResponseTiming(scope, source, answerId, now = Date.now()) {
  const previous = responseDuration(scope, answerId);
  if (previous !== null) return previous;
  if (!scope || !answerId || !source?.clientMessageId || source.localStatus) return null;
  const request = requests.get(JSON.stringify([scope, source.clientMessageId]));
  if (!request || request.answerId || now < request.startedAt) return null;
  const duration = now - request.startedAt;
  request.answerId = answerId;
  remember(answers, JSON.stringify([scope, answerId]), duration);
  return duration;
}

/** 目前消息契约不携带回复源ID；仅在两条回复之间恰好一个客户问题时建立可靠关联。 */
export function responseSource(messages, answer) {
  const index = messages.findIndex(item => item.businessMessageId === answer.businessMessageId);
  const candidates = [];
  for (let cursor = index - 1; cursor >= 0; cursor--) {
    const item = messages[cursor];
    if (["AI_AGENT", "BUSINESS_STAFF", "SUPPORT_STAFF", "SYSTEM"].includes(item.actorType)
      && item.messageType !== "SUPPLY_DEMAND_CARD") break;
    if (item.actorType === "CUSTOMER" && !item.localStatus) candidates.push(item);
  }
  return candidates.length === 1 ? candidates[0] : null;
}
